import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
    name: "secondsToHours",
    standalone: false,
})
export class SecondsToHoursPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        const timeEntry = moment.duration(Number(value), "seconds");
        return (
            Math.floor(timeEntry.asHours()) + moment.utc(timeEntry.asMilliseconds()).format(":mm")
        );
    }
}
